import { JsonTree } from '../JsonTree';
import { Table, Tooltip } from '@mantine/core';
import { IconHelp, IconInfoCircle } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import formatDate from '../../constants/formattedDate';
import prettifiedLabel from '../../constants/labelPrettifier';
import tagIcons from '../../constants/tagIcons';
import { getUserIdFromProfileId } from '../../helpers/profileId';
import AvatarInitials from '../AvatarInitials';
import EventIcon from './EventIcon';
import ProfileEventLink from './ProfileEventLink';
import { salesAgentEventLabel } from './salesAgentEvents';

const EventElements = ({
  events,
  pages,
  campaigns,
  emails,
  textMessages,
  viberMessages,
  pushNotifications,
  whatsappMessages,
  showProfileLink,
  eventTypes,
}) => {
  const domain = useSelector((state) => state.domain.domain);
  const eventElements = [];
  for (let i = 0; i < events.length; i++) {
    const event = events[i];
    let eventName =
      salesAgentEventLabel(event) ||
      eventTypes.find((t) => t.value === event.action)?.label ||
      prettifiedLabel(event.action);
    let eventLink = (
      <ProfileEventLink
        pages={pages}
        campaigns={campaigns}
        emails={emails}
        textMessages={textMessages}
        viberMessages={viberMessages}
        pushNotifications={pushNotifications}
        whatsappMessages={whatsappMessages}
        event={event}
      />
    );

    const icons = [];

    if (event?.userAgent?.browser) {
      icons.push(
        tagIcons.browser[event.userAgent.browser] || {
          icon: IconHelp,
          tooltip: event.userAgent.browser || 'Unknown browser',
        }
      );
    }

    if (event?.userAgent?.platform) {
      icons.push(
        tagIcons.platform[event.userAgent.platform] || {
          icon: IconHelp,
          tooltip: event.userAgent.platform,
        }
      );
    }

    for (const { key, icon, tooltip } of tagIcons.type) {
      if (event?.userAgent?.tags?.includes(key)) {
        icons.push({ icon, tooltip });
      }
    }

    const iconElements = [];
    for (const { icon: Icon, tooltip } of icons) {
      iconElements.push(
        <Tooltip key={iconElements.length} label={tooltip} position="top">
          <span style={{ paddingLeft: '5px', paddingRight: '5px' }}>
            <Icon size={20} />
          </span>
        </Tooltip>
      );
    }

    let profileName = getUserIdFromProfileId(event.profileId);
    if (event.profile?.firstName || event.profile?.lastName) {
      profileName = `${event.profile.firstName || ''} ${event.profile.lastName || ''}`.trim();
    } else if (event.profile?.email) {
      profileName = event.profile.email;
    } else if (event.profile?.phoneNumber) {
      profileName = event.profile.phoneNumber;
    }

    let profileLink = (
      <span>
        {profileName}
        <Tooltip label="The profile was deleted or merged" position="top">
          <span>
            <IconInfoCircle size={16} style={{ marginLeft: '5px', cursor: 'pointer', color: '#6f42c1' }} />
          </span>
        </Tooltip>
      </span>
    );
    if (event.profile) {
      profileLink = (
        <a
          href={`#/accounts/${domain.accountId}/domains/${domain.id}/profiles/${encodeURIComponent(
            event.profileId
          )}/events`}
        >
          {profileName}
        </a>
      );
    }

    const EventElement = () => {
      return (
        <Table.Tr ta="left">
          {showProfileLink ? (
            <Table.Td style={{ whiteSpace: 'nowrap' }}>
              <AvatarInitials user={event.profile} /> {profileLink}
            </Table.Td>
          ) : (
            ''
          )}
          <Table.Td>
            <EventIcon eventName={event.action} /> {eventName}
          </Table.Td>
          <Table.Td>{formatDate(event.timestamp)}</Table.Td>
          <Table.Td>{eventLink}</Table.Td>
          <Table.Td> {event.city} </Table.Td>
          <Table.Td> {event.country} </Table.Td>
          <Table.Td>
            <div style={{ whiteSpace: 'nowrap' }}>{iconElements}</div>
          </Table.Td>
          <Table.Td style={{ width: '25%' }}>
            <JsonTree data={event} />
          </Table.Td>
        </Table.Tr>
      );
    };

    eventElements.push(<EventElement key={i} />);
  }
  return eventElements;
};

export default EventElements;
